/***********************************************************/
/***********************************************************/
/* Vault Sell Checkout Module */
/***********************************************************/
/***********************************************************/

var vaultSellCheckoutModule = (function() {

  var url = '/checkout/vaultsell/',
    reqFields = [],
    token = '',
    locationChange = false,
    completionCheckCount = 0,
    completionCheckDelay = 0,
    costs = {
      storageFee: '0'
    },
    updateFlag;

  /*
   DESC: Initialize vault sell checkout. USED IN: /vaultCheckout/sell
   POST /api/v1/vaultsellcheckout/init
   */

  function init(cb) {
    var req = new Request(servicesUrl + url + 'init', {
      currency: getCurrency(),
      locationId: getLocation()
    });

    req.afterErrorDialogFunction(function(res) {
      if (res.location == null) {
        window.location.href = '/myaccount/dashboard';
      }
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
        sendComputeTaxes();
      }
    });

    req.call();
  }

  function showPaymentFields() {
    var $selectedOption = $('select[name=payment] option:selected');

    // Hide payment-field children and .form-field
    $('.payment-fields')
      .find('.form-field')
      .addClass('hide');

    // Remove error-field class so it wont mess up formValidationModule.focusOnFirstError
    $('.payment-fields').find('.form-field')
      .removeClass('error-field')
      .find('span.fail')
      .addClass('hide');

    $('.payment-fields').find('.form-field-' + $selectedOption.val()).each(function(i, field) {
      $(field).removeClass('hide');
    });
  }

  function handleResponse(res, currencyChanged, locationChanged) {
    // if(res.location == null) { // No product available for withdrawal, redirect to the dashboard.
    //   var options = {
    //     title: 'Sell Stored Bullion',
    //     message: 'You currently have no products available to sell.',
    //     okCallback: function() {
    //       window.location.href = '/myaccount/dashboard';
    //     }
    //   }
    //   var popup = new Popup(options);
    //   popup.render();
    //   return;
    // }

    $('.storage-location').text(res.location.title);

    if (res.requestLocation.id != res.location.id) { // Location changed by the API.
      var options = {
        title: 'Sell Stored Bullion',
        message: 'You don\'t have any stored items available to sell in ' + res.requestLocation.title + ". Location has been changed to " + res.location.title + ".",
        okCallback: function() {}
      }
      var popup = new Popup(options);
      popup.render();

      setLocation(res.location.id, res.location.shortName);
    }

    // Redraw payment dropdown

    var currentPaymentID = $.map($('select[name=payment] option'), function(option) {
      return option.value;
    });

    var newPaymentID = $.map(res.paymentMethods, function(method) {
      return method.id;
    });

    if (!arraysEqual(currentPaymentID, newPaymentID)) {
      console.log('Payment is not the Same!');
      $('#select-payment-container').html(tmpl($('#tmpl-vault-checkout-select-payment').html(), {
        obj: res
      }));
    }

    if (locationChanged) {
      $('#select-payment-container').html(tmpl($('#tmpl-vault-checkout-select-payment').html(), {
        obj: res
      }));
      $('.payment-fields').html(tmpl($('#tmpl-vault-sell-checkout-payment-fields').html(), {
        obj: res.paymentMethods
      }));
    }

    $('select[name=payment]').val(res.paymentMethodId);

    showPaymentFields();

    if (res.paymentMethods.length === 1) {
      $('select[name=payment]').addClass('hide');
    } else {
      $('select[name=payment]').removeClass('hide');
    }

    $('#payment-cost').text(res.costs.paymentCost);

    $('.location-name').html(res.location.title);

    if (res.costs.paymentCost) {
      $('.payment-cost-row').removeClass('hide');
      $('.payment-cost-row').find('.value').text(res.costs.paymentCost);
    } else {
      $('.payment-cost-row').addClass('hide');
      $('.payment-cost-row').find('.value').text('');
    }

    $('#storage-fee').text(res.costs.storageFee);

    if (res.costs.storageFee) {
      $('.storage-fee-row').removeClass('hide');
      $('.storage-fee-row').find('.value').text(res.costs.storageFee);
    } else {
      $('.storage-fee-row').addClass('hide');
      $('.storage-fee-row').find('.value').text('');
    }

    costs.storageFeePre2023 = res.costs.storageFeePre2023Plain;
    costs.storageFee2023 = res.costs.storageFee2023Plain;
    costs.storageFee2024Onwards = res.costs.storageFee2024OnwardsPlain;

    $('#sub-total').text(res.costs.subTotal);

    if (res.costs.subTotal) {
      $('.sub-total-row').removeClass('hide');
      $('.sub-total-row').find('.value').text(res.costs.subTotal);
    } else {
      $('.sub-total-row').addClass('hide');
      $('.sub-total-row').find('.value').text('');
    }

    $('#total').text(res.costs.total);

    if (res.costs.total) {
      $('.total-row').removeClass('hide');
      $('.total-row').find('.value').text(res.costs.total);
    } else {
      $('.total-row').addClass('hide');
      $('.total-row').find('.value').text('');
    }

    var bullionIds = [];
    $.each(res.cart.items, function(i, item) {
      bullionIds.push(item.productId);
      if (item.quantityChanged) {
        $('.quantity[data-id=' + item.productId + ']').val(item.quantity);
        //$('.quantity[data-id=' + item.productId + ']').attr('qty', item.quantity);
      }
      $('.quantity[data-id=' + item.productId + ']').attr('total-price', item.totalPricePlain);
      $('.vault-quantity[data-id=' + item.productId + ']').text(item.vaultQuantity);

      if (item.unitPrice != '' && item.unitPrice) {
        $('.cart-unit-price[data-id=' + item.productId + ']').html(item.unitPrice);
        $('.total-unit-price[data-id=' + item.productId + ']').html(item.totalPrice);
      }
    });

    // Remove non existing bullion
    $.each($('.vault-quantity'), function(i, el) {
      if ($.inArray($(this).data('id'), bullionIds) == -1) {
        $('.vault-quantity[data-id=' + $(this).data('id') + ']').closest('tr').remove();
      }
    });

    // Add missing.
    $.each(res.cart.items, function(i, item) {
      if ($('.vault-quantity[data-id=' + item.productId + ']').length == 0) {
        if (i == 0) {
          $('.checkout-table > tbody').prepend(tmpl($('#tmpl-vault-sell-cart-items-table').html(), {
            obj: item
          }));
        } else {
          var prev = $('.vault-quantity[data-id=' + res.cart.items[i - 1].productId + ']').closest('tr');
          prev.after(tmpl($('#tmpl-vault-sell-cart-items-table').html(), {
            obj: item
          }));
        }
      }
    });

    // Update token
    token = res.priceLockToken;
  }

  function generateTaxFormFields() {
    var data = {
      priceLockToken: token,
      locationId: getLocation(),
      currency: getCurrency(),
      countryCode: $('#country').val(),
      productsString: generateTaxProductString(),
      storageFeePre2023: costs.storageFeePre2023,
      storageFee2023: costs.storageFee2023,
      storageFee2024Onwards: costs.storageFee2024Onwards
    }

    return data;
  }

  function sendComputeTaxes() {
    var data = generateTaxFormFields();

    var xhr = taxes(data, function(res) {
      updateCheckoutTaxItems(res);
    }, 1, false);
  }

  /*
    DESC: Get taxes buy checkout. USED IN: /buy/checkout page
    GET /checkout/buycheckout/taxes
  */
  function taxes(data, cb, noLoader, getXHR, warningCancelCb, warningOkCb) {
    if (new Loading().isShowing()) {
      return null;
    }

    var req = new Request(servicesUrl + url + 'taxes', data);

    req.getXHR = getXHR || false;

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    req.afterWarningDialogFunction(function(res) {
      typeof warningOkCb === 'function' && warningOkCb(res);
    });

    req.afterWarningCancelDialogFunction(function(res) {
      typeof warningCancelCb === 'function' && warningCancelCb(res);
    });

    if (noLoader) {
      req.send();
    } else {
      req.call();
    }

    if (req.getXHR) {
      return req.xhr;
    }
  }

  /*
    DESC: Update Checkout Tax items. USED IN: /buy/checkout page
  */
  function updateCheckoutTaxItems(res) {
    console.log(res);

    if (res.taxes.storageFeeVat) {
      $('.storage-fee-vat-row').removeClass('hide');
      $('.storage-fee-vat-row').find('.subtitle').text(res.taxes.storageTaxLabel);
      $('.storage-fee-vat-row').find('.value').text(res.taxes.storageFeeVat);
    } else {
      $('.storage-fee-vat-row').addClass('hide');
      $('.storage-fee-vat-row').find('.value').text('');
    }

    if (res.taxes.totalVat) {
      $('.total-vat-row').removeClass('hide');
      $('.total-vat-row').find('.subtitle').text(res.taxes.totalTaxLabel);
      $('.total-vat-row').find('.value').text(res.taxes.totalVat);
    } else {
      $('.total-vat-row').addClass('hide');
      $('.total-vat-row').find('.value').text('');
    }

  }

  function sendUpdate(cb, getXHR, isLocationChanged, isCurrencyChanged) {
    var locationChange = isLocationChanged ? true : false;
    var currencyChanged = isCurrencyChanged ? true : false;
    var xhr = update({
      currency: getCurrency(),
      countryCode: $('#country').val(),
      paymentMethodId: $('select[name=payment]').val(),
      locationId: getLocation(),
      productsString: isLocationChanged ? '' : generateProductString(),
      priceLockToken: token
    }, function(res) {
      handleResponse(res, currencyChanged, locationChange);
      typeof cb === 'function' && cb(res);
      sendComputeTaxes();
    }, 1, getXHR);

    if (getXHR) {
      return xhr;
    }
  }

  function loadPage(res) {

    $('.currency-wrap .radio-one-line input, .change-currency').off('click');

    if (res.location) {
      $('.vault-checkout-wrap').html(tmpl($('#tmpl-vault-sell-checkout-payment').html(), {
        obj: res
      }));

      $('.payment-fields').html(tmpl($('#tmpl-vault-sell-checkout-payment-fields').html(), {
        obj: res.paymentMethods
      }));

      //$('.storage-location-wrap').html(tmpl($('#tmpl-storage-location').html(), { obj: res }));

      $('.storage-location').html(res.location.title);

      if (res.locations.length < 2) {
        $('.change-storage-location').addClass('hide');
      } else {
        $('.change-storage-location').removeClass('hide');
      }

      $('.change-storage-location').on('click', function() {
        var popup = new PopupStorageLocation(res.locations);
        popup.render();
      });
      showHideBranchCode(res);
      initLandCode('#country-code-selection');

      $.each(res.additionalCountries, function(i, country) {
        $('.country-select').prepend('<option value="' + country.countryCode + '">' + country.countryName + '</option>');
        $('.country-code-selection').prepend('<option value="' + country.countryCode + '" data-country="' + country.countryCodeLC + '" data-country-name="' + country.countryName + '" data-code="' + country.phoneCode + '">+' + country.phoneCode + ' ' + country.countryName + '</option>');
      });

      accountModule.setDetails(res.address);
      $('.customer-info .country').html('<br/>' + $('#country option:selected').text());
      $('.customer-info .phone-number').html('<br/> +' + $('#country-code-selection option:selected').data('code') + ' ' + res.address.phoneNumber);
    }

    // if(detectIE() || isFirefox()) {
    //   $('.txt-pin-code').attr('type', 'password');
    // }

    handleResponse(res);
    countrySelect('#country');

    $('#header-location').on('change', function() {
      sendUpdate(null, false, true);
    });

    $('#storage-location').on('change', function() {
      $('#header-location').val($(this).val());
      $('#header-location').trigger('change');
    });

    // if(localStorage.getItem('checkout-country') !== null) {
    //   $('#country').val(localStorage.getItem('checkout-country')).trigger('change');
    //   $('.customer-info .info .country').html('<br/>' + $('#country option:selected').text());
    // }

    // Country changed
    $('#country').on('change', function() {
      sendUpdate();
      //localStorage.setItem('checkout-country', $(this).val());
    });

    // Payment clicked
    $('.wrap-body').on('change', 'select[name=payment]', function() {
      var _this = $(this),
        $selectedOption = $('select[name=payment] option:selected');

      $('.select-payment-description').addClass('hide');

      $('.select-payment-description[data-id=' + $selectedOption.val() + ']').removeClass('hide');

      showPaymentFields();

      if ($selectedOption.attr('data-currency')) {
        changeCurrency($selectedOption.data('currency'));

        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }
        updateFlag = sendUpdate(null, true, false, true);
      } else {
        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }
        updateFlag = sendUpdate(null, true);
      }

      // if(!$selectedOption.attr('data-currency')) {
      //   if(typeof updateFlag === 'object') {
      //     updateFlag.abort();
      //   }
      //   updateFlag = sendUpdate(null, true);
      // } else {
      //   console.log('Change Currency');

      //   if(getCurrency() !== $selectedOption.data('currency')) {
      //     var cryptoCur = $selectedOption.text();
      //     var options = {
      //       title: generateChangeCryptoCurrencyTitle(cryptoCur),
      //       message: generateChangeCryptoCurrencyMessage(cryptoCur),
      //       okCallback: function() {
      //         changeCurrency($selectedOption.data('currency'));

      //         if(typeof updateFlag === 'object') {
      //           updateFlag.abort();
      //         }
      //         updateFlag = sendUpdate(null, true, false, true);
      //       }
      //     };

      //     var popup = new Popup(options);
      //     popup.render();
      //   }
      // }
    });

    // Change value
    $('.vault-checkout-wrap').on('change', '.quantity', debounce(function() {
      handleChange($(this).data('id'), false);
      // if(typeof updateFlag === 'object') {
      //   updateFlag.abort();
      // }
      // updateFlag = sendUpdate(null, true);
    }, 300));

    $('.vault-checkout-wrap').on('keyup', '.quantity', debounce(function(e) {
      if (isKeycodeNumber(e)) {
        handleChange($(this).data('id'), false);
        // if(typeof updateFlag === 'object') {
        //   updateFlag.abort();
        // }
        // updateFlag = sendUpdate(null, true);
      }
    }, 300));

    $('.currency-wrap .radio-one-line input').on('click', debounce(function() {
      var _this = $(this),
        value = _this.val();

      if (getCurrency() !== value) {
        $('.vault-checkout-wrap .payment').empty();
        changeCurrency(value);

        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }

        updateFlag = sendUpdate(function(res) {
          $('.payment-fields').html(tmpl($('#tmpl-vault-sell-checkout-payment-fields').html(), {
            obj: res.paymentMethods
          }));
          showHideBranchCode(res);
        }, true, false, true);

        headerCurrencyChange();
      }
    }, 300));

    $('#payment-change-currency').on('click', function() {
      var popupCurrency = new PopupCurrency();
      popupCurrency.render();
    });

    // $('.wrap-body').on('click', '.change-currency', function() {
    //   var _this = $(this),
    //       value = _this.data('currency');

    //   if(getCurrency() !== value) {
    //     var options = {
    //       title: 'Currency Changed to Bitcoin',
    //       message: 'Please note that the currency has been changed to Bitcoin.',
    //       okCallback: function() {
    //         $('.vault-checkout-wrap .payment').empty();
    //         changeCurrency(value);
    //         $('.currency-wrap .radio-one-line input[value="' + getCurrency() + '"]').prop('checked', true);

    //         sendUpdate(function(res) {
    //           $('.payment-fields').html(tmpl($('#tmpl-vault-sell-checkout-payment-fields').html(), { obj: res.paymentMethods }));
    //           showHideBranchCode(res);
    //         }, false, false, true);
    //       }
    //     };

    //     var popup = new Popup(options);
    //     popup.render();
    //   }
    // });

    /*$('.currency-selection').on('click', function() {
     var _this = $(this),
     value = _this.data('target');

     if(getCurrency() !== value) {
     $('.vault-checkout-wrap .payment').empty();
     changeCurrency.call(_this, value, true);
     popupModule.open($('.popup-loading'), 'popupLoading');

     sendUpdate(function(res) {
     popupModule.close($('.popup-loading'), 'popupLoading');
     $('.payment-fields').html(tmpl($('#tmpl-vault-sell-checkout-payment-fields').html(), { obj: res.paymentMethods }));
     if(getCurrency() !== 'BTC') {
     showHideBranchCode(res);
     }
     });
     } else {
     popupModule.close($('.popup-currency'), 'popupCurrency');
     }

     });*/

    $('#btn-place-order').on('click', function() {
      formValidationModule.validateForm($('.vault-checkout-wrap'), 'Sell Stored Bullion', function(data) {
        data.currency = getCurrency();
        data.countryCode = $('#country-code-selection').val();
        data.paymentMethodId = $('select[name=payment]').val();
        data.productsString = generateProductString();
        data.priceLockToken = token;
        data.phoneCountry = $('#country-code-selection').val();
        data.countryCode = $('#country').val();
        data.paymentMethodFields = processSellPaymentFieldString(data);
        data.locationId = getLocation();
        data.ct = getCT();

        formValidationModule.addData(data, $('.user-form-info'), false);
        if (validateAgreeCheckboxes('Sell Stored Bullion')) {
          if (isCryptoCurrency()) {
            var extra = '';
            if (getCurrency() == 'BCH') {
              extra = ' I acknowledge that BullionStar will send Bitcoin Cash coins from the Node chain.';
            }

            var address = $('.payment-fields .form-field:visible input').val(),
              title = $('.currency-wrap .radio-one-line input[value="' + getCurrency() + '"]').next('label').find('.bullion-radio-title-half').text();
            var option = {
              title: title,
              message: 'By clicking on the "I Confirm" button below, I confirm that the funds will be sent to the <b>' + title + '</b> address: ' + address + '. I acknowledge that BullionStar is not responsible for incorrectly selected cryptocurrencies or incorrectly stated cryptocurrency addresses.' + extra,
              customButtons: true,
              buttons: [{
                link: false,
                name: 'Cancel',
                action: 'close'
              }, {
                link: false,
                name: 'I Confirm',
                action: 'callback',
                callback: function() {
                  confirm(data);
                }
              }]
            }
            var popup = new Popup(option);
            popup.render();
          } else {
            confirm(data);
          }
        }
      }, null, true);
    });

    // Show Edit Details Form
    $('#btn-edit-details').on('click', function(e) {
      $('.customer-info').addClass('hide');
      $('.user-form-info').removeClass('hide');
    });
  }

  /*
   DESC: Update vault sell checkout. USED IN: /vault/sell page
   GET /api/v1/vaultsellcheckout/update
   productsString:1106
   currency:SGD
   countryCode:SG
   shippingMethodId:3
   paymentMethodId:13
   */
  function update(data, cb, noLoader, getXHR) {
    if (new Loading().isShowing()) {
      return null;
    }

    var req = new Request(servicesUrl + url + 'update', data);

    //req.useRequestId(true);
    req.getXHR = getXHR || false;

    req.afterErrorDialogFunction(function(res) {
      if (res.location == null) {
        window.location.href = '/myaccount/dashboard';
      }
    });

    req.success(function(res) {
      if (res.success) {
        typeof cb === 'function' && cb(res);
      }
    });

    if (noLoader) {
      req.send();
    } else {
      req.call();
    }

    if (req.getXHR) {
      return req.xhr;
    }
  }

  /*
   DESC: Confirm vault sell checkout. USED IN: /vault/sell page
   GET /api/v1/vaultsellcheckout/confirm
   productsString:1106
   currency:SGD
   shippingMethodId:3
   paymentMethodId:13
   priceLockToken:
   email:
   name:
   phoneCountry
   company:test
   address1:Marina Bay Financial Center
   address2:Level 39, 10 Marina Boulevard
   city:Santa rosa
   state:
   postCode:4412
   countryCode:SG
   */
  function confirm(data) {

    data.machineId = getMachineId();
    data.sessionId = sessionModule.getSessionId();
    var req = new Request(servicesUrl + url + 'confirm', data);

    req.afterErrorDialogFunction(function(res) {
      if (res.accountLocked) {
        authenticationModule.logout();
        return;
      }

      if (res.location == null) {
        window.location.href = '/myaccount/dashboard';
        return;
      }

      formValidationModule.showError('.vault-checkout-wrap', res.errorParameter);
    });

    req.success(function(res) {
      if (res.transactionId && res.transactionId != '') {
        waitForCompletion(req, res.transactionId);
      } else {
        handleResponse(res);
        req.hideLoader();
        sendComputeTaxes();
      }
    });

    req.dontHideLoaderOnSuccess(true);
    req.call();
  }

  function waitForCompletion(confirmReq, transactionId) {
    completionCheckCount = 0;
    completionCheckDelay = 500;

    setTimeout(checkForCompletion, completionCheckDelay, confirmReq, transactionId);
  }

  /*
    DESC: Check for completion status of a submitted order. USED IN: checkout page
    transactionId:1234-1234-1234-1234
  */
  function checkForCompletion(confirmReq, transactionId) {
    completionCheckCount++;
    if (completionCheckCount > 200) {
      completionCheckDelay = 3000;
    } else if (completionCheckCount > 50) {
      completionCheckDelay = 1000;
    } else {
      completionCheckDelay = 500;
    }

    new Request(servicesUrl + url + 'status', {
        transactionId: transactionId
      })
      .error(function(json) {
        confirmReq.hideLoader();
        var popup = new Popup({
          title: json.title,
          message: json.message
        });
        popup.render();
      }).success(function(json) {
        if (json.url && json.url != '') {
          window.location.href = json.url;
        } else if (json.stockChanges) {
          sendUpdate();
        } else {
          setTimeout(checkForCompletion, completionCheckDelay, confirmReq, transactionId);
        }
      }).send();
  }

  var quantityTimer = null;

  function handleChange(productId, delay) {
    if (delay) {
      if (quantityTimer != null) {
        clearTimeout(quantityTimer);
        quantityTimer = null;
      }
      quantityTimer = setTimeout(vaultSellCheckoutHandleChange, 200, productId);
    } else {
      var _this = $('.quantity[data-id=' + productId + ']');

      if (!_this.length) return;
      var quantityString = _this.val();
      quantityString = quantityString.trim();
      if (quantityString.length == 0) {
        quantityString = 0;
      }

      var quantity = parseInt(quantityString, 10);
      if (!isNaN(quantity)) {

        if (typeof updateFlag === 'object') {
          updateFlag.abort();
        }

        updateFlag = sendUpdate(null, true);
      }
    }
  }

  function generateProductString() {
    var str = '';

    $('.vault-checkout-wrap .quantity-row .quantity').each(function() {
      var productId = $(this).attr('data-id');
      var quantity = $(this).val() || 0;
      if (str.length > 0) {
        str += ',';
      }
      str += productId + ',' + quantity;
    });

    return str;
  }

  function generateTaxProductString() {
    var str = '';

    $('.vault-checkout-wrap .quantity').each(function() {
      var productId = $(this).attr('data-id');
      var quantity = parseInt($(this).val());
      var totalPrice = $(this).attr('total-price');
      if (isNaN(quantity)) {
        quantity = 0;
      }

      if (str.length > 0) {
        str += ',';
      }
      str += productId + '#' + quantity + '#' + totalPrice;
    });

    return str;
  }

  return {
    init: init,
    loadPage: loadPage,
    update: update,
    //handleChange: handleChange,
    confirm: confirm,
    generateProductString: generateProductString
  }
}());

function vaultSellCheckoutHandleChange(productId) {
  vaultSellCheckoutModule.handleChange(productId, false);
}

/* Add for mocha testing */
// Basically it make the vaultsellcheckoutModule nodejs module compatible
if (typeof module !== 'undefined' && typeof exports === 'object') {
  module.exports = vaultSellCheckoutModule;
}